<template>
  <div class="url-rewriter">
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable */ 
import qs from "query-string"
export default {
  name: 'URLRewriter',
  created()
  {
    var result = this.searchForOauthResponse();
    if(!result)
    {
      this.tryRewriteURL();
    }
  },
  computed : {
    mainUrl()
    {
      return document.location.href.split("/").splice(0,3).join("/");
    }
  },
  data()
  {
    return {

    }
  },
  methods : {
    searchForOauthResponse()
    {
      
      var querystring = qs.parse(window.document.location.search);
      var keys = Object.keys(querystring);
      if(keys.indexOf("code") >= 0  && keys.indexOf("session_state") >= 0  && keys.indexOf("state") >= 0 )
      {
        document.location.href=`${this.mainUrl}/#/auth/pkce?code=${querystring.code}&session_state=${querystring.session_state}&state=${querystring.state}`;
        return true;
      }
      return false;
    },
    tryRewriteURL()
    {
     
      var splits = document.location.href.split("#");
      var urlBeginning = splits[0];
      var hash = splits.length > 1 ? splits[1] : null;
      var mainUrl = splits[0].split("/").slice(0,3).join("/") + "/";
      var currentlyAtRoot = (mainUrl == urlBeginning);
      var path =  !currentlyAtRoot ? "/" + urlBeginning.replace(mainUrl, "") : "/";
      if(!currentlyAtRoot)
      {
        var newTarget = `${mainUrl}#${path}`;
        document.location.href = newTarget;
      }

      return;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/url-rewriter.vue